<template>
  <b-row style="position:relative">
    <b-col cols="12" ref="l">
      <div class="filters-container">
        <DropdownColumns v-model="fields" class="customize" />
      </div>
      <b-table
        id="entity-log-table"
        :busy.sync="isBusy"
        show-empty
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :hover="true"
        :striped="true"
        stacked="md"
        :items="provider"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
      >
        <template v-slot:empty="scope">
          <div class="text-center">{{ $t(scope.emptyText) }}</div>
        </template>

        <template v-slot:head()="scope">{{ $t(scope.label) }}</template>
        <template v-slot:cell(timestamp)="data">
          <span>{{ mom_unix(data.value).format(tableDateLong) }}</span>
        </template>
      </b-table>
      <div class="container-fluid">
        <div class="row">
          <div style="white-space:nowrap;" class="my-2">
            <PaginationSelect
              v-model="perPage"
              :options="paginationOpts"
              variant="light"
              size="sm"
            />
            <span>
              &nbsp;
              <i18n path="Showing {start}-{end} of {total} rows" tag="span">
                <span slot="start">{{(currentPage-1) * perPage + 1}}</span>
                <span slot="end">{{currentPage * perPage}}</span>
                <span slot="total">{{totalRows}}</span>
              </i18n>
            </span>
            <b-button
              size="sm"
              @click.stop="$root.$emit('bv::refresh::table', 'entity-log-table')"
              class="ml-2 refresh"
              variant="light"
              :title="$t('Refresh')"
            >
              <i class="icon-refresh"></i>
            </b-button>
          </div>
          <nav class="ml-auto mt-2">
            <b-pagination
              size="md"
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
            />
          </nav>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import moment from "moment";
import startCase from "@/shared/strings";
import { errorConf } from "@/shared/notifications";
import DropdownColumns from "@/components/DropdownColumns";
import PaginationSelect from "@/components/PaginationSelect";
import timeFormat from "@/shared/timeFormat";

export default {
  name: "entityLogs",
  components: {
    DropdownColumns,
    PaginationSelect
  },
  props: ["event_id"],
  data: function() {
    return {
      tableName: "entityLogs",
      isBusy: false,
      sortBy: "timestamp",
      sortDesc: true,
      fields: [
        {
          key: "eid",
          label: "Entity ID",
          sortable: true,
          class: "d-none"
        },
        { key: "timestamp", sortable: true, class: "" },
        { key: "message", sortable: true, class: "" }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,

      filter: null,
      filterField: null
    };
  },
  computed: {
    tableDateLong() {
      return timeFormat.tableDateLong;
    },
    paginationOpts() {
      return [
        {
          value: 5
        },
        {
          value: 10
        },
        {
          value: 15
        },
        {
          value: 25
        },
        {
          value: 50
        }
      ];
    }
  },
  methods: {
    refresh() {
      this.$root.$emit("bv::refresh::table", "entity-log-table");
    },
    provider(ctx, callback) {
      const loading = this.$loading.open({
        container: this.$refs.cnt
      });

      const paginationData = {
        rowsPerPage: this.perPage,
        page: this.currentPage,
        exactFields: ["entity_id", "entity_type"],
        exactValues: [[this.event_id], [1]]
      };

      if (this.filter && this.filterField) {
        paginationData.likeValues = [this.filter];
        paginationData.likeFields = [this.filterField];
      } else {
        paginationData.likeValues = [];
        paginationData.likeFields = [];
      }

      if (this.sortBy) {
        paginationData.sortBy = [this.sortBy];
        paginationData.sortDirection = [this.sortDesc ? "DESC" : "ASC"];
      }

      this.$store
        .dispatch("entityLog/fetch", paginationData)
        .then(resp => {
          this.totalRows = resp.data.total;
          callback(resp.data.rows);
        })
        .catch(err => {
          this.$bvToast.toast(
            this.$t(err.message),
            errorConf(this.$t("Error"))
          );
          this.totalRows = 0;
          callback([]);
        })
        .finally(() => {
          loading.close();
        });

      // Must return null or undefined to signal b-table that callback is being used
      return null;
    },
    redirect() {},
    mom_unix(val) {
      if (!val)
        return {
          format() {
            return "";
          }
        };
      return moment.unix(val / 1e9);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>


